import { identity, isEmpty } from 'ramda';
import React from 'react';

import { Collapse } from 'reactstrap';

import MultiSelectFilter from '../Inputs/MultiSelectFilter';
import { Loading } from '../Loading';

class CollapseCust extends React.Component {
  state = {
    optionsList: undefined,
    collapse: false,
    [this.props.name]: '',
  };
  accordionButtonRef = React.createRef();

  componentDidUpdate(prevProps) {
    const { focusIndexPosition, indexPosition } = this.props;
    if (focusIndexPosition === indexPosition && prevProps.focusIndexPosition !== focusIndexPosition) {
      this.accordionButtonRef.focus();
    }
  }

  handleInputChange = (value) => {
    this.props.clearFilterSearch(false);
    this.setState({
      optionsList: this.filterItems(this.props.data, value),
      [this.props.name]: value,
    });
  };

  filterItems(arr, query) {
    return arr.filter((el) => el.name.toLowerCase().indexOf(query.toLowerCase()) > -1);
  }

  toggle = (collapse) => {
    this.props.setHeight ? this.props.setHeight(this.props, collapse) : void 0;
    this.setState({
      collapse: !collapse,
    });
  };

  clientIdsSelectedEvent = (inputFields, idObj) => {
    const checkIndex = inputFields.clientIdsSelected ? inputFields.clientIdsSelected.indexOf(idObj.id) : -1;
    if (checkIndex !== -1) {
      inputFields.clientIdsSelected.splice(checkIndex, 1);
    } else {
      inputFields.clientIdsSelected?.push(idObj.id);
    }
    this.props.filter(this.props);
  };

  onKeyDownAccordionButton = (e) => {
    const { key } = e;
    const { focusToFirstPosition, indexPosition, setFocusPosition } = this.props;

    if (key !== 'Tab') {
      e.stopPropagation();
      e.preventDefault();
    }

    // eslint-disable-next-line default-case
    switch (key) {
      case 'Enter':
        this.toggle(this.state.collapse);
        break;
      case 'ArrowUp':
        setFocusPosition(indexPosition - 1);
        break;
      case 'ArrowDown':
        setFocusPosition(indexPosition + 1);
        break;
      case 'Tab':
        if (!e.shiftKey && !this.state.collapse) {
          e.preventDefault();
          setFocusPosition(indexPosition + 1);
        }
        break;
      case 'Escape':
        this.props.setFocusPosition(this.props.indexPosition - 1);
        if (this.state.collapse === true) {
          this.setState({
            collapse: false,
          });
        }
        if (this.props.indexPosition == 0) {
          focusToFirstPosition(e);
        }
        break;
    }
  };

  onKeyDownCollapse = (e) => {
    if (e.key === 'Escape') {
      e.stopPropagation();
      this.setState({
        collapse: false,
      });
      this.accordionButtonRef.focus();
    }
    if (e.key === 'ArrowUp') {
      e.stopPropagation();
      this.accordionButtonRef.focus();
    }
    if (e.key === 'ArrowDown') {
      e.stopPropagation();
      e.preventDefault();
      this.props.setFocusPosition(this.props.indexPosition + 1);
    }
  };

  render() {
    const lengthTosetMaxHeight = this.props.collapseNumber.length;
    const collapse = this.state.collapse;

    const dataHolder = this.props.clearAllMultiSelect ? this.props.data : this.state.optionsList || this.props.data;

    const value = this.props.clearAllMultiSelect ? '' : this.state[this.props.name];

    return (
      <div className="collapse-filter transition">
        <span
          ref={(ref) => (this.accordionButtonRef = ref)}
          role="application"
          className={'line-height-15 collapse-Title ' + (collapse ? 'bottom-border' : '')}
          aria-expanded={collapse}
          aria-controls={`accContainer${this.props.indexPosition}`}
          onClick={() => {
            this.toggle(collapse);
          }}
          data-testid={`collapseButton${this.props.indexPosition}`}
          onKeyDown={this.onKeyDownAccordionButton}
          tabIndex={this.props.hasFocus ? 0 : -1}
          onFocus={() => {
            this.props.setFocusPosition(this.props.indexPosition);
          }}>
          <i className={'pTop-2 pRight-15 fas fa-caret-' + (collapse ? 'down' : 'right')} />
          {this.props.name}
        </span>
        <Collapse isOpen={collapse}>
          <div
            id={`accContainer${this.props.indexPosition}`}
            onKeyDown={this.onKeyDownCollapse}
            className={[
              'filter-multiselect',
              this.props.searchBar && dataHolder.length > 3 ? 'max-height' : '',
              isEmpty(this.props.data) ? 'filter-loading' : '',
            ]
              .filter(identity)
              .join(' ')}>
            <Loading show={isEmpty(this.props.data)} classNames={['filter-multiselect-loading']} />
            <MultiSelectFilter
              searchBar={this.props.searchBar}
              required
              onInputChange={this.handleInputChange}
              clientIdsSelectedEvent={this.clientIdsSelectedEvent}
              tabIndex={this.props.hasFocus ? 0 : -1}
              placeholder="Search"
              clientIdsSelected={this.props.clientIdsSelected}
              name={this.props.name}
              dataObj={dataHolder}
              originalData={this.props.data}
              value={value}
              noResult
              focusToFirstPosition={(e) => {
                if (this.props.lastCollapse) {
                  e.preventDefault();
                  this.props.focusToFirstPosition();
                }
              }}
              maxHeight={lengthTosetMaxHeight === 0 ? '' : lengthTosetMaxHeight === 1 ? this.props.maxHeight : 196}
            />
          </div>
        </Collapse>
      </div>
    );
  }
}

export default CollapseCust;
